import Vue from 'vue'
import Router from 'vue-router'
import store from './store'
import apis from './config/apis'
import axios from 'axios'

Vue.use(Router)

// 获取原型对象上的push函数
const originalPush = Router.prototype.push
Router.prototype.push = function push(location: any) {
  let res: any = originalPush.call(this, location)
  return res.catch((err: any) => err)
}
const originalreplace = Router.prototype.replace;
Router.prototype.replace = function replace(location: any) {
  let res: any = originalreplace.call(this, location)
  return res.catch((err: any) => err)
}


const router = new Router({
  routes: [
    {
      path: '/',
      name: 'home',
      component: () => import('./Login.vue')
    },
    {
      path: '/login',
      name: 'login',
      component: () => import('./Login.vue')
    },
    {
      path: '/index',
      name: 'index',
      component: () => import('./views/Index.vue'),
      redirect: (to) => {
        if (store.getters.getUserInfo.role === 'VISITOR') {
          return '/index/CabinetMangement'
        } else {
          if (store.getters.getUserInfo.monitor == true) {
            return '/index/mengniubench'
          }
          return '/index/workbench'
        }
      },
      children: [
        {
          path: 'workbench',
          name: 'workbench',
          component: () => import('./views/workbench/index.vue'),
          meta: {
            keepAlive: true
          }
        },
        {
          path: 'mengniubench',
          name: 'mengniubench',
          component: () => import('./views/mengniubench/index.vue'),
          meta: {
            keepAlive: true
          }
        },
        /*现在 news
         * */
        // {
        //   path: "testbench",
        //   name: "testbench",
        //   component: () =>
        //     import("./views/testbench/index.vue")
        // },
        {
          path: 'CabinetMangement',
          name: 'CabinetMangement',
          component: () =>
            import('./views/operation/cabinet-management/index.vue')
        },
        {
          path: 'deviceMangement',
          name: 'deviceMangement',
          component: () =>
            import('./views/operation/cabinet-management/deviceMangement.vue')
        },
        {
          path: 'cooperation',
          name: 'cooperation',
          component: () =>
            import('./views/operation/order-management/cooperation.vue')
        },
        {
          path: 'OrderMangement',
          name: 'OrderMangement',
          component: () =>
            import('./views/operation/order-management/index.vue')
        },
        {
          path: 'JointMangement',
          name: 'JointMangement',
          component: () =>
            import('./views/operation/joint-management/index.vue')
        },
        {
          path: 'OrderDetails',
          name: 'OrderDetails',
          component: () =>
            import('./views/operation/order-management/OrderDetails.vue')
        },
        {
          path: 'JointDetails',
          name: 'JointDetails',
          component: () =>
            import('./views/operation/joint-management/JointDetails.vue')
        },
        {
          path: 'openRecordOrderDetails',
          name: 'openRecordOrderDetails',
          component: () =>
            import('./views/operation/order-management/openRecordOrderDetails.vue')
        },
        // {
        //   path: 'StockMangement',
        //   name: 'StockMangement',
        //   component: () =>
        //     import('./views/operation/stock-management/index.vue')
        // },
        {
          path: 'StockGoodsManage',
          name: 'StockGoodsManage',
          component: () =>
            import('./views/operation/stock-management/stockGoodsManage.vue')
        },
        {
          path: 'inspection',
          name: 'inspection',
          component: () => import('./views/inspection/index.vue')
        },
        {
          path: 'inspectionUpdate',
          name: 'inspectionUpdate',
          component: () => import('./views/inspection/inspectionUpdate.vue')
        },

        {
          path: 'area',
          name: 'area',
          component: () => import('./views/inspection/area.vue')
        },
        {
          path: 'region',
          name: 'region',
          component: () => import('./views/inspection/region.vue')
        },
        {
          path: 'point',
          name: 'point',
          component: () => import('./views/inspection/point.vue')
        },
        {
          path: 'inventorydetails',
          name: 'inventorydetails',
          component: () => import('./views/inspection/inventorydetails.vue')
        },
        {
          path: 'specification',
          name: 'specification',
          component: () => import('./views/inspection/specification.vue')
        },
        {
          path: 'openRecord',
          name: 'openRecord',
          component: () => import('./views/inspection/openRecord.vue')
        },
        {
          path: 'interfaceUsageList',
          name: 'interfaceUsageList',
          component: () => import('./views/inspection/interfaceUsageList.vue')
        },
        {
          path: 'inspectionDA',
          name: 'inspectionDA',
          component: () => import('./views/inspectionDA/index.vue')
        },
        {
          path: 'goods',
          name: 'goods',
          component: () => import('./views/inspectionDA/goods.vue')
        },
        {
          path: 'sales',
          name: 'sales',
          component: () => import('./views/inspectionDA/sales.vue')
        },
        {
          path: 'ReplenishmentMangement',
          name: 'ReplenishmentMangement',
          component: () =>
            import('./views/operation/replenishment-management/index.vue')
        },
        {
          path: 'ReplenishmentDetails',
          name: 'ReplenishmentDetails',
          component: () =>
            import('./views/operation/replenishment-management/ReplenishmentDetails.vue')
        },
        {
          path: 'ActivityMangement',
          name: 'ActivityMangement',
          component: () =>
            import('./views/operation/activity-management/index.vue')
        },
        {
          path: 'AddActivity',
          name: 'AddActivity',
          component: () =>
            import('./views/operation/activity-management/AddActivity.vue')
        },
        {
          path: 'PointMangement',
          name: 'PointMangement',
          component: () => import('./views/point/point-management/index.vue')
        },
        {
          path: 'modifypoint',
          name: 'modifypoint',
          component: () =>
            import('./views/point/point-management/modifypoint.vue')
        },
        {
          path: 'PointType',
          name: 'PointType',
          component: () => import('./views/point/point-type/index.vue')
        },
        {
          path: 'modifytype',
          name: 'modifytype',
          component: () => import('./views/point/point-type/modifytype.vue')
        },
        {
          path: 'LineMangement',
          name: 'LineMangement',
          component: () => import('./views/point/line-management/index.vue')
        },
        {
          path: 'modifyline',
          name: 'modifyline',
          component: () =>
            import('./views/point/line-management/modifyline.vue')
        },
        {
          path: 'checkline',
          name: 'checkline',
          component: () => import('./views/point/line-management/checkline.vue')
        },
        {
          path: 'checkpoint',
          name: 'checkpoint',
          component: () =>
            import('./views/point/point-management/checkpoint.vue')
        },
          {
          path: 'restock',
          name: 'restock',
          component: () =>
            import('./views/restock/index.vue')
        },
          {
          path: 'restocked',
          name: 'restocked',
          component: () =>
            import('./views/restock/restocked.vue')
        },
         {
          path: 'deviceList',
          name: 'deviceList',
          component: () =>
            import('./views/restock/deviceList.vue')
        },
         {
          path: 'modifyRestock',
          name: 'modifyRestock',
          component: () =>
            import('./views/restock/modifyRestock.vue')
        },
        {
          path: 'checkpointtype',
          name: 'checkpointtype',
          component: () => import('./views/point/point-type/checkpointtype.vue')
        },
        {
          path: 'UserList',
          name: 'UserList',
          component: () => import('./views/user/UserList.vue')
        },
        {
          path: 'AddUserList',
          name: 'AddUserList',
          component: () => import('./views/user/AddUserList.vue')
        },
        {
          path: 'UserMangement',
          name: 'UserMangement',
          component: () => import('./views/user/UserMangement.vue')
        },
        {
          path: 'AddUser',
          name: 'AddUser',
          component: () => import('./views/user/AddUser.vue')
        },
        {
          path: 'ModifyUser',
          name: 'ModifyUser',
          component: () => import('./views/user/ModifyUser.vue')
        },
        {
          path: 'replenishMangement',
          name: 'replenishMangement',
          component: () => import('./views/user/replenishMangement.vue')
        },
        {
          path: 'Addreplenish',
          name: 'Addreplenish',
          component: () => import('./views/user/Addreplenish.vue')
        },
        {
          path: 'modifyreplenish',
          name: 'modifyreplenish',
          component: () => import('./views/user/modifyreplenish.vue')
        },
        {
          path: 'PointCooperationPartners',
          name: 'PointCooperationPartners',
          component: () => import('./views/user/PointCooperationPartners.vue')
        },
        {
          path: 'modifyCooperation',
          name: 'modifyCooperation',
          component: () => import('./views/user/modifyCooperation.vue')
        },
        {
          path: 'contract',
          name: 'contract',
          component: () => import('./views/customer/Contract.vue')
        },
        {
          path: 'addcontract',
          name: 'addcontract',
          component: () => import('./views/customer/AddContract.vue')
        },
        {
          path: 'Finance',
          name: 'Finance',
          component: () => import('./views/finance/index.vue')
        },
        {
          path: 'voucherManage',
          name: 'voucherManage',
          component: () => import('./views/finance/voucherManage.vue')
        },
        {
          path: 'voucherDetail',
          name: 'voucherDetail',
          component: () => import('./views/finance/voucherDetail.vue')
        },
        {
          path: 'balanceList',
          name: 'balanceList',
          component: () => import('./views/finance/balanceList.vue')
        },
        {
          path: 'dimensionList',
          name: 'dimensionList',
          component: () => import('./views/finance/dimensionList.vue')
        },
        {
          path: 'financeAuditList',
          name: 'financeAuditList',
          component: () => import('./views/finance/auditList.vue')
        },
        {
          path: 'splitBillList',
          name: 'splitBillList',
          component: () => import('./views/splitBill/splitBillList.vue')
        },
        {
          path: 'splitBill',
          name: 'splitBill',
          component: () => import('./views/splitBill/splitBill.vue')
        },
        {
          path: 'splitBillConfigList',
          name: 'splitBillConfigList',
          component: () => import('./views/splitBill/splitBillConfigList.vue')
        },
        {
          path: 'splitBillConfig',
          name: 'splitBillConfig',
          component: () => import('./views/splitBill/splitBillConfig.vue')
        },
        {
          path: 'splitBillAlreadyList',
          name: 'splitBillAlreadyList',
          component: () => import('./views/splitBill/splitBillAlreadyList.vue')
        },
        {
          path: 'splitBillAlready',
          name: 'splitBillAlready',
          component: () => import('./views/splitBill/splitBillAlready.vue')
        },
        {
          path: 'transactionTotal',
          name: 'transactionTotal',
          component: () => import('./views/finance/transactionTotal.vue')
        },
        {
          path: 'transactionDetail',
          name: 'transactionDetail',
          component: () => import('./views/finance/transactionDetail.vue')
        },
        {
          path: 'transactionSummary',
          name: 'transactionSummary',
          component: () => import('./views/finance/transactionSummary.vue')
        },
        {
          path: 'Presentation',
          name: 'Presentation',
          component: () => import('./views/finance/Presentation.vue')
        },
        {
          path: 'DetailPresen',
          name: 'DetailPresen',
          component: () => import('./views/finance/DetailPresen.vue')
        },
        {
          path: 'suggestion',
          name: 'suggestion',
          component: () => import('./views/associator/suggestion/index.vue')
        },
        {
          path: 'modifysuggestion',
          name: 'modifysuggestion',
          component: () =>
            import('./views/associator/suggestion/modifysuggestion.vue')
        },
        {
          path: 'reportFailure',
          name: 'reportFailure',
          component: () => import('./views/associator/reportFailure/index.vue')
        },
        {
          path: 'failureDetail',
          name: 'failureDetail',
          component: () =>
            import('./views/associator/reportFailure/failureDetail.vue')
        },
        {
          path: 'cabinetView',
          name: 'cabinetView',
          component: () =>
            import('./views/operation/cabinet-management/cabinetView.vue')
        },
        {
          path: 'cabinetUpdate',
          name: 'cabinetUpdate',
          component: () =>
            import('./views/operation/cabinet-management/cabinetUpdate.vue')
        },
        {
          path: 'shopping',
          name: 'shopping',
          component: () => import('./views/shopping/index.vue')
        },
        {
          path: 'shoppingDetail',
          name: 'shoppingDetail',
          component: () => import('./views/shopping/shoppingDetail.vue')
        },
        {
          path: 'shoppingCategory',
          name: 'shoppingCategory',
          component: () => import('./views/shopping/shoppingCategory.vue')
        },
        {
          path: 'shoppingManage',
          name: 'shoppingManage',
          component: () => import('./views/shopping/shoppingManage.vue')
        },
        {
          path: 'shoppingModel',
          name: 'shoppingModel',
          component: () => import('./views/shopping/shoppingModel.vue')
        },
         {
          path: 'unifiedPrice',
          name: 'unifiedPrice',
          component: () => import('./views/shopping/unifiedPrice.vue')
        },
          {
          path: 'addPrice',
          name: 'addPrice',
          component: () => import('./views/shopping/addPrice.vue')
        },
        {
          path: 'shoppingCategoryUpdate',
          name: 'shoppingCategoryUpdate',
          component: () => import('./views/shopping/shoppingCategoryUpdate.vue')
        },
        {
          path: 'shoppingCategoryView',
          name: 'shoppingCategoryView',
          component: () => import('./views/shopping/shoppingCategoryView.vue')
        },
        {
          path: 'shoppingManageUpdate',
          name: 'shoppingManageUpdate',
          component: () => import('./views/shopping/shoppingManageUpdate.vue')
        },
        {
          path: 'shoppingModelView',
          name: 'shoppingModelView',
          component: () => import('./views/shopping/shoppingModelView.vue')
        },
        {
          path: 'shoppingModelUpdate',
          name: 'shoppingModelUpdate',
          component: () => import('./views/shopping/shoppingModelUpdate.vue')
        },
        {
          path: 'logMangement',
          name: 'logMangement',
          component: () => import('./views/log/index.vue')
        },
        {
          path: 'logDetail',
          name: 'logDetail',
          component: () => import('./views/log/detail.vue')
        },
        {
          path: 'loginMangement',
          name: 'loginMangement',
          component: () => import('./views/log/loginMangement.vue')
        },
        {
          path: 'pushMangement',
          name: 'pushMangement',
          component: () => import('./views/log/pushMangement.vue')
        },
        {
          path: 'helpDocument',
          name: 'helpDocument',
          component: () => import('./views/log/helpDocument.vue')
        },
        {
          path: 'QRcodeMangement',
          name: 'QRcodeMangement',
          component: () =>
            import('./views/operation/qrcode-mangement/index.vue')
        },
        {
          path: 'QRcodeAdd',
          name: 'QRcodeAdd',
          component: () => import('./views/operation/qrcode-mangement/add.vue')
        },
        {
          path: 'pickupMangement',
          name: 'pickupMangement',
          component: () =>
            import('./views/operation/pickup-management/index.vue')
        },
        {
          path: 'updatePickup',
          name: 'updatePickup',
          component: () =>
            import('./views/operation/pickup-management/updatePickup.vue')
        },
        {
          path: 'VideoView',
          name: 'VideoView',
          component: () =>
            import('./views/operation/cabinet-management/videoView.vue')
        },
        {
          path: 'memberList',
          name: 'memberList',
          meta: {
            c_name: '会员列表',
            p_name: '会员管理'
          },
          component: () => import('./views/member/list.vue')
        },
        {
          path: 'memberDetail',
          name: 'memberDetail',
          meta: {
            c_name: '会员详情',
            p_name: '会员列表'
          },
          component: () => import('./views/member/detail.vue')
        },
        {
          path: 'memberRemain',
          name: 'memberRemain',
          meta: {
            c_name: '会员详情',
            p_name: '会员列表'
          },
          component: () => import('./views/member/memberRemain.vue')
        },
        {
          path: 'transactionDA',
          name: 'transactionDA',
          meta: {
            c_name: '交易分析',
            p_name: '数据分析'
          },
          component: () => import('./views/da/transaction.vue')
        },
        {
          path: 'memberDA',
          name: 'memberDA',
          meta: {
            c_name: '会员分析',
            p_name: '数据分析'
          },
          component: () => import('./views/da/member.vue')
        },
        {
          path: 'shopDA',
          name: 'shopDA',
          meta: {
            c_name: '商品分析',
            p_name: '数据分析'
          },
          component: () => import('./views/da/shop.vue')
        },
        {
          path: 'tradeAreaDA',
          name: 'tradeAreaDA',
          meta: {
            c_name: '线路分析',
            p_name: '数据分析'
          },
          component: () => import('./views/da/tradeArea.vue')
        },
        {
          path: 'marketDA',
          name: 'marketDA',
          meta: {
            c_name: '营销分析',
            p_name: '数据分析'
          },
          component: () => import('./views/da/market.vue')
        },
        {
          path: 'discountManagement',
          name: 'discountManagement',
          component: () => import('./views/discount/list.vue')
        },
        {
          path: 'openStatistics',
          name: 'openStatistics',
          component: () => import('./views/report/openStatistics.vue')
        },
        {
          path: 'goodsSell',
          name: 'goodsSell',
          component: () => import('./views/report/goodsSell.vue')
        },
        {
          path: 'goodsStatistics',
          name: 'goodsStatistics',
          component: () => import('./views/report/goodsStatistics.vue')
        },
        {
          path: 'goodsDailysales',
          name: 'goodsDailysales',
          component: () => import('./views/report/goodsDailysales.vue')
        },
        {
          path: 'statisticalDetail',
          name: 'statisticalDetail',
          component: () => import('./views/report/statisticalDetail.vue')
        },
        {
          path: 'discountEdit',
          name: 'discountEdit',
          component: () => import('./views/discount/edit.vue')
        },
        {
          path: 'systemSetting',
          name: 'systemSetting',
          component: () => import('./views/system/setting.vue')
        },
        {
          path: 'replenisher',
          name: 'replenisher',
          component: () => import('./views/user/replenisher.vue')
        },
        {
          path: 'stockHistory',
          name: 'stockHistory',
          component: () =>
            import('./views/operation/cabinet-management/history.vue')
        },
        {
          path: 'goodsGroup',
          name: 'goodsGroup',
          component: () => import('./views/shopping/goodsGroup.vue')
        },
        {
          path: 'goodsGroupUpdate',
          name: 'goodsGroupUpdate',
          component: () => import('./views/shopping/goodsGroupUpdate.vue')
        },
        {
          path: 'goodsRecognitionRate',
          name: 'goodsRecognitionRate',
          component: () => import('./views/shopping/goodsRecognitionRate.vue')
        },
        {
          path: 'advertisement',
          name: 'advertisement',
          component: () => import('./views/advertisement/index.vue')
        },
        {
          path: 'addAdvertisement',
          name: 'addAdvertisement',
          component: () => import('./views/advertisement/addAdvertisement.vue')
        },
        {
          path: 'advertisingdelivery',
          name: 'advertisingdelivery',
          component: () =>
            import('./views/advertisement/advertisingdelivery.vue')
        },
        {
          path: 'addDelivery',
          name: 'addDelivery',
          component: () => import('./views/advertisement/addDelivery.vue')
        },
        {
          path: 'applyAdList',
          name: 'applyAdList',
          component: () => import('./views/advertisement/applyAdList.vue')
        },
        {
          path: 'applyAd',
          name: 'applyAd',
          component: () => import('./views/advertisement/applyAd.vue')
        },
        {
          path: "examine",
          name: "examine",
          component: () => import("./views/advertisement/examine.vue")
        },
        {
          path: "InventoryManagement",
          name: "InventoryManagement",
          component: () => import("./views/operation/cabinet-management/inventoryList.vue")
        },
        {
          path: "inventoryDetail",
          name: "inventoryDetail",
          component: () => import("./views/operation/cabinet-management/inventoryDetail.vue")
        },
        {
          path: 'machineAudit',
          name: 'machineAudit',
          component: () => import('./views/operation/cabinet-management/machineAudit.vue')
        },
        {
          path: 'gradeSetting',
          name: 'gradeSetting',
          component: () => import('./views/operation/level-management/gradeSetting.vue')
        },
        {
          path: 'gradeView',
          name: 'gradeView',
          component: () => import('./views/operation/level-management/gradeView.vue')
        },
        {
          path: 'gradeAudit',
          name: 'gradeAudit',
          component: () => import('./views/operation/level-management/gradeAudit.vue')
        },
        {
          path: 'hierarchyUserDetail',
          name: 'hierarchyUserDetail',
          component: () => import('./views/operation/level-management/userDetail.vue')
        },
        {
          path: 'auditDetail',
          name: 'auditDetail',
          component: () => import('./views/operation/level-management/auditDetail.vue')
        },
      ]
    }
    // {
    //   path: '*',
    //   name: 'NotFour-404',
    //   component: () => import('./views/error-404.vue')
    // }
  ]
})

function getUserInfo() {
  return axios.get(apis.get_user).then((res: any) => {
    if (res.data.code === 200) {
      store.commit('setUserInfo', res.data.data)
      store.commit('setRole', res.data.data)
    }
  })
}
router.beforeEach((to: any, from: any, next: any) => {
  if (to.name === 'login') {
    store.commit('setUserInfo', {})
    store.commit('setRole', '')
    next()
  } else {
    if (!store.getters.getUserInfo.biz_id) {
      getUserInfo()
        .then(() => {
          next()
        })
        .catch(() => {
          next()
        })
    } else {
      next()
    }
  }
})
export default router
